import { render, staticRenderFns } from "./MenuCategoriesEdit.vue?vue&type=template&id=5c72aa9e&scoped=true&"
import script from "./MenuCategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./MenuCategoriesEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenuCategoriesEdit.vue?vue&type=style&index=0&id=5c72aa9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72aa9e",
  null
  
)

export default component.exports